import {
  ArticleListingPageStoryblok,
  ArticleStoryblok,
} from "@/types/blok-types";
import "./article-listing.css";

import {
  fetchArticles,
  fetchListingPages,
} from "@/bloks/ArticleListingPage/fetchers";
import { fetchFeaturedArticle } from "@/lib/storyblok/fetchStories";
import clsx from "clsx";
import Link from "next/link";
import { useMemo } from "react";
import { StoryblokStory } from "storyblok-generate-ts";
import { Card } from "../ArticleCard/ArticleCard";
import ClientArticleGrid from "./ClientArticleGrid";
import styles from "./article-listing-page.module.css";

type TabData = {
  text: string;
  slug: string;
};

export const Tabs = ({
  tabs,
  current,
}: {
  tabs: TabData[];
  current: TabData;
}) => {
  return (
    <nav
      className={clsx(
        styles.heading__wrapper,
        (!tabs || tabs.length < 1) && styles["no-border"]
      )}
    >
      {!tabs?.length && <h1>{current.text}</h1>}
      {tabs?.map((target, key) => {
        if (target.slug === current.slug)
          return <h1 key={key}>{target.text}</h1>;

        const slug = target.slug === "artikler" ? "" : target.slug;
        return (
          <Link href={`/artikler/${slug}`} key={key}>
            {target.text}
          </Link>
        );
      })}
    </nav>
  );
};

const FeaturedArticle = ({
  featuredArticle,
  preview,
}: {
  featuredArticle: StoryblokStory<ArticleStoryblok> | undefined;
  preview: boolean;
}) => {
  return (
    <section
      className={clsx(styles.featured__article, "alp__featured")}
      data-layout="page"
      data-no-padding-bottom="true"
      data-container="small"
    >
      {featuredArticle && <Card article={featuredArticle} preview={preview} />}
    </section>
  );
};

const ArticleListingPage = ({
  blok,
  slug,
  preview,
  data,
  listings,
  articles,
}: {
  blok: ArticleListingPageStoryblok;
  listings?: Awaited<ReturnType<typeof fetchListingPages>>;
  slug?: string;
  preview: boolean;
  data: Awaited<ReturnType<typeof fetchFeaturedArticle>>;
  articles?: Awaited<ReturnType<typeof fetchArticles>>;
}) => {
  const tabs = useMemo(() => {
    return listings?.map((listing) => ({
      slug: listing.slug,
      text: listing.content.title || listing.name,
    }));
  }, [listings]);

  return (
    <>
      <section
        className={styles.root}
        data-layout="page"
        data-no-padding-bottom="true"
      >
        <Tabs
          tabs={tabs ?? []}
          current={{
            text: blok.title,
            slug: slug ?? "artikler",
          }}
        />
        <p className={styles.description}>{blok.description}</p>
      </section>
      <FeaturedArticle
        featuredArticle={data?.featuredArticle}
        preview={preview}
      />
      <ClientArticleGrid articles={articles} preview={preview} />
    </>
  );
};

export default ArticleListingPage;
